<template>
  <div v-if="vpnState.isLocked" class="vpn-lock-overlay">
    <div class="vpn-lock-box">
      <div class="vpn-lock-icon">⚠️</div>
      <h3 class="vpn-lock-title">VPN Connection Detected</h3>
      <p class="vpn-lock-msg">
        {{ vpnState.message || "VPN usage is strictly prohibited on this platform." }}
      </p>
      <p class="vpn-lock-timer">
        Disconnect your VPN now, or you will be logged out in <b>{{ vpnState.remainingSeconds }}</b> seconds.
      </p>
    </div>
  </div>
</template>

<script>
import { vpnState } from "@/utils/vpnCheck";

export default {
  name: "VpnLockOverlay",
  setup() {
    return {
      vpnState
    };
  }
};
</script>

<style scoped>
.vpn-lock-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.85);
  backdrop-filter: blur(8px);
  z-index: 999999999; /* Absolute highest to block EVERYTHING */
  display: flex;
  align-items: center;
  justify-content: center;
}

.vpn-lock-box {
  background: white;
  padding: 40px;
  border-radius: 12px;
  text-align: center;
  max-width: 450px;
  width: 90%;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.4);
  animation: slideIn 0.3s ease-out;
}

.vpn-lock-icon {
  font-size: 48px;
  margin-bottom: 15px;
}

.vpn-lock-title {
  color: #dc2626;
  font-weight: 700;
  font-size: 22px;
  margin-bottom: 10px;
  font-family: inherit;
}

.vpn-lock-msg {
  color: #4b5563;
  font-size: 16px;
  margin-bottom: 20px;
}

.vpn-lock-timer {
  background: #fee2e2;
  color: #991b1b;
  padding: 15px;
  border-radius: 8px;
  font-size: 15px;
  margin: 0;
}

.vpn-lock-timer b {
  font-size: 20px;
  color: #dc2626;
}

@keyframes slideIn {
  from {
    transform: translateY(-20px) scale(0.95);
    opacity: 0;
  }
  to {
    transform: translateY(0) scale(1);
    opacity: 1;
  }
}
</style>
